<template>


    <!-- publications -->
    <div class="offcanvas offcanvas--search">
        <h2 class="offcanvas-title">
            <span class="offcanvas-title__text">Search</span>
            <a class="offcanvas-close js-offcanvas-close" href="#"><img :src="closeBlackIcon"></a>
        </h2>

        <form role="search" id="publications-search-offcanvas" class="form-search form-search--offcanvas form-inline">

            <input class="form-control offcanvas-control" type="text"
                placeholder="Search publications, authors, topics, etc." v-model="search_input"
                @change="onSearchInput" />

            <a class="search-results__close js-search-results-close d-none" href="#">
                <img :src="closeGreyIcon"></a>

        </form>



        <!--/Search Results-->
        <div class="search-results">
            <p v-if="globalSearchLoading"></p>

            <template v-else>
                <!-- {{globalSearchResult}} -->
                <h2 class="search-result__category">Publications</h2>
                <div v-for="resultTitle in globalSearchResult.publications.nodes" :key="resultTitle">
                    <a class="searchwp-live-search-result" v-bind:href="resultTitle.link">
                        <div class="search-result__item">
                            <div class="search-result__img">
                                
                            </div>

                            <div class="search-result__content">
                                <h2>{{resultTitle.title}}</h2>
                            </div>
                        </div>
                    </a>
                </div>



                <h2 class="search-result__category">Projects</h2>
                <div v-for="resultTitle in globalSearchResult.projects.nodes" :key="resultTitle">
                    <a class="searchwp-live-search-result" v-bind:href="resultTitle.link">
                        <div class="search-result__item">
                            <div class="search-result__img">
                                
                            </div>

                            <div class="search-result__content">
                                <h2>{{resultTitle.title}}</h2>
                            </div>
                        </div>
                    </a>
                </div>





                <h2 class="search-result__category">Blog Posts</h2>

                <div v-for="resultTitle in globalSearchResult.posts.nodes" :key="resultTitle">

                    <a class="searchwp-live-search-result" v-bind:href="resultTitle.link">
                        <div class="search-result__item">
                            <div class="search-result__img">
                                
                            </div>

                            <div class="search-result__content">
                                <h2>{{resultTitle.title}}</h2>
                            </div>
                        </div>
                    </a>

                </div>



                <h2 class="search-result__category">Staff Members</h2>
                <div v-for="resultTitle in globalSearchResult.staffMembers.nodes" :key="resultTitle">
                    <a class="searchwp-live-search-result" v-bind:href="resultTitle.link">
                        <div class="search-result__item">
                            <div class="search-result__img">
                                
                            </div>

                            <div class="search-result__content">
                                <h2>{{resultTitle.title}}</h2>
                            </div>
                        </div>
                    </a>
                </div>





















            </template>


            
            <!--/search result item-->
        </div>
    </div>

</template>



<script setup>
import { ref, provide, computed, watch } from "vue";
import { useQuery } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { useDebouncedRef } from './debouncedRef'

import globalSearchQuery from '../graphql/results/globalSearchQuery.gql'
import closeGreyIcon from '@/assets/close-circle-grey-sm.png'
import closeBlackIcon from '@/assets/close-black-sm.png'



let search_input = useDebouncedRef('');
/**
 * ::::::::: Get Results :::::::::
 **/

const { result: globalSearchResult, loading: globalSearchLoading, error: globalSearchError, options: globalSearchOptions, variables: globalSearchVariables } = useQuery( globalSearchQuery, { search_input: search_input } );


const computedImgBaseUrl = computed(() => {

    let url = new URL( window.location.href );
    let urlPath = url.pathname

    // console.log( 'url=' )
    let imgBase = url.hostname + '/wp-content/themes/scattergood/img/'
    
    return imgBase

})

const imgageUrl = (path) => {
  return '../../../../img/' + path;
}



const onSearchInput = (e) => {  
  search_input.value = e.target.value;
  console.log( computedImgBaseUrl )
}
</script>

